import { safeShaderReplace, type ShaderProgramLike } from "./shaderUtils";

// Collecting shader code strings into arrays and then joining them reduces number of temporary string allocations compared to using string.replace().
// The savings are on the order of tens of megabytes.
export interface DesignMaterialShaderChunks {
  fragmentDefinitions: string[];
  fragmentEvaluateLayers: string[];
  fragmentPrelight: string[];
  heightWrites: string[];
  clipping: string[];
  aoModulation: string[];
  fog?: string; // Replaces fog_fragment include
  lightsFragmentMaps?: string; // Replaces lights_fragment_maps include
}

export function includeCommonDesignMaterialShaderChunks(
  shader: ShaderProgramLike,
  designMaterialShaderChunks: Pick<
    DesignMaterialShaderChunks,
    "lightsFragmentMaps" | "fragmentDefinitions" | "clipping" | "aoModulation"
  >,
) {
  if (designMaterialShaderChunks.lightsFragmentMaps !== undefined) {
    shader.fragmentShader = safeShaderReplace(
      shader.fragmentShader,
      "#include <lights_fragment_maps>",
      designMaterialShaderChunks.lightsFragmentMaps,
      "includeCommonDesignMaterialShaderChunks (lights_fragment_maps)",
    );
  }
  shader.fragmentShader = safeShaderReplace(
    shader.fragmentShader,
    "#include <normal_pars_fragment>",
    `#include <normal_pars_fragment>
    ${designMaterialShaderChunks.fragmentDefinitions.join("\n")}
    `,
    "includeCommonDesignMaterialShaderChunks (normal_pars_fragment)",
  );
  shader.fragmentShader = safeShaderReplace(
    shader.fragmentShader,
    "#include <clipping_planes_fragment>",
    `#include <clipping_planes_fragment>
    ${designMaterialShaderChunks.clipping.join("\n")}
    `,
    "includeCommonDesignMaterialShaderChunks (clipping_planes_fragment)",
  );
  shader.fragmentShader = safeShaderReplace(
    shader.fragmentShader,
    "#include <aomap_fragment>",
    `#include <aomap_fragment>
    ${designMaterialShaderChunks.aoModulation.join("\n")}`,
    "includeCommonDesignMaterialShaderChunks (aomap_fragment)",
  );
}
